/**
 * Shared bits for astro-form fields: the label (with an optional required `*`)
 * and the inline error line. Keeps every field visually consistent.
 */
import { ReactNode } from 'react'

export function FieldLabel({ children, required }: { children: ReactNode; required?: boolean }) {
  return (
    <span className="text-bodySmall text-textSecondary">
      {children}
      {required && <span className="text-textAccentPrimary"> *</span>}
    </span>
  )
}

export function FieldError({ message }: { message?: string }) {
  if (!message) return null
  return <p className="text-bodySmall text-errorPrimary">{message}</p>
}
